module.exports = __webpack_public_path__ + "static/media/avatar.9d82bac2.jpg";